import React from 'react';
import type { MultiKey } from '../core/MultiKey';
import type { ScenarioLocation } from '../../lib/planningData';
import type { Assortment_AdminFragment } from '../../graphql';

export type PortCostPair = [locationId: number, assortmentId: number];

export type MarcuraPortCostParams = [
  portExternalId: string,
  assortmentGroupExternalId: string,
];

export type PortCostData = {
  id: number;
  marcura_port_id: string;
  marcura_group_id: string;
  location_id: number;
  assortment_id: number;
  data: {
    costs: Array<{
      dwtMax: number;
      dwtMin: number;
      segmentName?: string | null;
      costLoading?: number | null;
      costDischarging?: number | null;
    }>;
  };
};

export type MarcuraPortCosts = {
  locationsById: Map<number, ScenarioLocation>;
  assortmentsById: Map<number, Assortment_AdminFragment>;
  get: (...pair: PortCostPair) => PortCostData | undefined;
  set: (data: PortCostData) => void;
  map: MultiKey<PortCostData, MarcuraPortCostParams>;
};

export interface MarcuraPortCostContextProps {
  portCosts: MarcuraPortCosts;
  queuePortCostsForPairs: (pairs: PortCostPair[]) => void;
  fetchMissingMarcuraPortCosts: (
    existingPortCosts: MarcuraPortCosts,
    portIds: Set<number>,
    assortmentIds: Set<number>,
  ) => Promise<MarcuraPortCosts>;
  resetPortCosts: () => void;
  setLocations: (locationsById: Map<number, ScenarioLocation>) => void;
  setAssortments: (
    assortmentsById: Map<number, Assortment_AdminFragment>,
  ) => void;
}

export const MarcuraPortCostContext = React.createContext<
  MarcuraPortCostContextProps | undefined
>(undefined);
